/* Quick add - card "+" button, option picker modal and Apple Pay / wallet button.
   Ported from the live theme (layout/theme.liquid inline script), plus a click
   handler so cards only need data attributes instead of embedding product JSON. */
(function() {
  window.bcQuickAdd = function(productId, variants, options, title, image, price, compareAtPrice, handle) {
  var existing = document.getElementById('bc-qa-overlay');
  if (existing) existing.remove();

  var selectedOptions = {};

  function getMatchingVariant() {
    return variants.find(function(v) {
      return options.every(function(opt, i) {
        return v.options[i] === selectedOptions[opt.name];
      });
    });
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' EGP';
  }

  function getAvailableValuesForOption(optIndex) {
    return variants
      .filter(function(v) {
        return options.every(function(opt, i) {
          if (i === optIndex) return true;
          return !selectedOptions[opt.name] || v.options[i] === selectedOptions[opt.name];
        });
      })
      .map(function(v) { return v.options[optIndex]; });
  }

  function renderOptions(modal) {
    // Remove existing option sections
    modal.querySelectorAll('.bc-qa-option-section').forEach(function(el) { el.remove(); });
    var addBtn = modal.querySelector('.bc-qa-add-btn');

    options.forEach(function(opt, optIndex) {
      var section = document.createElement('div');
      section.className = 'bc-qa-option-section';

      var labelEl = document.createElement('div');
      labelEl.className = 'bc-qa-option-label';
      labelEl.textContent = opt.name;
      section.appendChild(labelEl);

      var btnsEl = document.createElement('div');
      btnsEl.className = 'bc-qa-option-btns';

      var availableValues = getAvailableValuesForOption(optIndex);

      opt.values.forEach(function(val) {
        var btn = document.createElement('button');
        btn.className = 'bc-qa-opt-btn';
        btn.textContent = val;
        btn.dataset.option = opt.name;
        btn.dataset.value = val;

        var isAvailable = availableValues.indexOf(val) !== -1;
        var testVariant = variants.find(function(v) {
          return options.every(function(o, i) {
            if (i === optIndex) return v.options[i] === val;
            return !selectedOptions[o.name] || v.options[i] === selectedOptions[o.name];
          });
        });

        if (!isAvailable || (testVariant && !testVariant.available)) {
          btn.classList.add('unavailable');
        }

        if (selectedOptions[opt.name] === val) {
          btn.classList.add('active');
        }

        btn.onclick = function() {
          if (btn.classList.contains('unavailable')) return;
          selectedOptions[opt.name] = val;
          // If color changes, clear size selection
          if (optIndex === 0) {
            options.forEach(function(o, i) {
              if (i > 0) delete selectedOptions[o.name];
            });
          }
          renderOptions(modal);
          updateAddBtn(modal);
        };

        btnsEl.appendChild(btn);
      });

      section.appendChild(btnsEl);
      modal.insertBefore(section, addBtn);
    });
  }

  // ---- Express checkout -------------------------------------------------
  // A real wallet button (Apple Pay / Shop Pay) cannot be created in JS, so it
  // is fetched per-variant from the `quick-buy-payment` section. Devices with
  // no wallet get a plain "Buy it now" that adds the item and goes to checkout.
  var walletToken = 0;   // guards against out-of-order fetch responses

  function walletCapable() {
    try {
      return !!(window.ApplePaySession && window.ApplePaySession.canMakePayments());
    } catch (e) {
      return false;
    }
  }

  function showBuyNowOnly(walletWrap, buyNowBtn) {
    walletWrap.hidden = true;
    walletWrap.innerHTML = '';
    buyNowBtn.hidden = false;
  }

  function updateExpress(modal) {
    var walletWrap = modal.querySelector('.bc-qa-wallet');
    var buyNowBtn = modal.querySelector('.bc-qa-buynow-btn');
    if (!walletWrap || !buyNowBtn) return;

    var allSelected = options.every(function(opt) { return selectedOptions[opt.name]; });
    var variant = allSelected ? getMatchingVariant() : null;
    var ready = !!(variant && variant.available);

    walletToken++;

    if (!ready) {
      showBuyNowOnly(walletWrap, buyNowBtn);
      buyNowBtn.disabled = true;
      buyNowBtn.textContent = 'Buy it now';
      return;
    }

    buyNowBtn.disabled = false;
    buyNowBtn.textContent = 'Buy it now';

    if (!handle || !walletCapable()) {
      showBuyNowOnly(walletWrap, buyNowBtn);
      return;
    }

    var myToken = walletToken;
    // Deliberately no XHR header: on this store it makes /products/<handle>
    // return the product JSON instead of the rendered section.
    fetch('/products/' + encodeURIComponent(handle) +
          '?section_id=quick-buy-payment&variant=' + variant.id)
      .then(function(r) { return r.ok ? r.text() : Promise.reject(new Error(r.status)); })
      .then(function(html) {
        if (myToken !== walletToken) return;          // a newer selection won
        walletWrap.innerHTML = html;
        if (!walletWrap.querySelector('shopify-accelerated-checkout')) {
          throw new Error('no wallet button in response');
        }
        walletWrap.hidden = false;
        buyNowBtn.hidden = true;
        if (window.Shopify && window.Shopify.PaymentButton &&
            typeof window.Shopify.PaymentButton.init === 'function') {
          window.Shopify.PaymentButton.init();
        }
      })
      .catch(function() {
        if (myToken !== walletToken) return;
        showBuyNowOnly(walletWrap, buyNowBtn);       // silent fallback
      });
  }

  function updateAddBtn(modal) {
    var addBtn = modal.querySelector('.bc-qa-add-btn');
    var allSelected = options.every(function(opt) {
      return selectedOptions[opt.name];
    });
    if (!allSelected) {
      addBtn.disabled = true;
      addBtn.textContent = 'Select options';
      updateExpress(modal);
      return;
    }
    var variant = getMatchingVariant();
    if (!variant || !variant.available) {
      addBtn.disabled = true;
      addBtn.textContent = 'Unavailable';
    } else {
      addBtn.disabled = false;
      addBtn.textContent = 'Add to Cart';
    }
    updateExpress(modal);
  }

  function buildModal() {
    var overlay = document.createElement('div');
    overlay.className = 'bc-qa-overlay';
    overlay.id = 'bc-qa-overlay';

    var modal = document.createElement('div');
    modal.className = 'bc-qa-modal';

    var closeBtn = document.createElement('button');
    closeBtn.className = 'bc-qa-modal__close';
    closeBtn.innerHTML = '&times;';
    closeBtn.onclick = function() { overlay.remove(); };
    modal.appendChild(closeBtn);

    var header = document.createElement('div');
    header.className = 'bc-qa-modal__header';
    if (image) {
      var img = document.createElement('img');
      img.src = image;
      img.className = 'bc-qa-modal__img';
      img.alt = title;
      header.appendChild(img);
    }
    var info = document.createElement('div');
    var priceHtml = formatMoney(price);
    if (compareAtPrice && compareAtPrice > price) {
      priceHtml = '<s class="bc-qa-modal__price-compare">' + formatMoney(compareAtPrice) + '</s> <span class="bc-qa-modal__price-current">' + formatMoney(price) + '</span>';
    }
    info.innerHTML = '<div class="bc-qa-modal__title">' + title + '</div><div class="bc-qa-modal__price">' + priceHtml + '</div>';
    header.appendChild(info);
    modal.appendChild(header);

    var addBtn = document.createElement('button');
    addBtn.className = 'bc-qa-add-btn';
    addBtn.textContent = 'Select options';
    addBtn.disabled = true;

    addBtn.onclick = function() {
      var variant = getMatchingVariant();
      if (!variant) return;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        addBtn.textContent = 'Added!';
        overlay.remove();
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      })
      .catch(function() {
        addBtn.disabled = false;
        addBtn.textContent = 'Error — try again';
      });
    };

    modal.appendChild(addBtn);

    // Wallet button lands here when the device supports one.
    var walletWrap = document.createElement('div');
    walletWrap.className = 'bc-qa-wallet';
    walletWrap.hidden = true;
    modal.appendChild(walletWrap);

    // Fallback express button for everything else.
    var buyNowBtn = document.createElement('button');
    buyNowBtn.className = 'bc-qa-buynow-btn';
    buyNowBtn.textContent = 'Buy it now';
    buyNowBtn.disabled = true;
    buyNowBtn.onclick = function() {
      var variant = getMatchingVariant();
      if (!variant) return;
      buyNowBtn.disabled = true;
      buyNowBtn.textContent = 'Please wait...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() { window.location.href = '/checkout'; })
      .catch(function() {
        buyNowBtn.disabled = false;
        buyNowBtn.textContent = 'Error — try again';
      });
    };
    modal.appendChild(buyNowBtn);

    overlay.appendChild(modal);

    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) overlay.remove();
    });

    document.body.appendChild(overlay);
    renderOptions(modal);
    updateAddBtn(modal);
  }

  buildModal();
};
})();


/* Card button -> load the product, then open the modal.
   Buttons carry: data-handle, data-price, data-compare (cents). */
document.addEventListener('click', function (e) {
  var btn = e.target.closest && e.target.closest('.bc-quickadd-btn');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  if (btn.dataset.loading) return;
  btn.dataset.loading = '1';
  var handle = btn.getAttribute('data-handle');
  fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (p) {
      var img = p.featured_image || '';
      if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=200';
      window.bcQuickAdd(
        String(p.id), p.variants, p.options, p.title, img,
        Number(btn.getAttribute('data-price')) || p.price,
        Number(btn.getAttribute('data-compare')) || 0,
        p.handle
      );
    })
    .catch(function () { window.location.href = btn.getAttribute('data-url') || ('/products/' + handle); })
    .then(function () { delete btn.dataset.loading; });
}, true);
